import { render, staticRenderFns } from "./MediaFiliacionComponent.vue?vue&type=template&id=28e3f784&scoped=true"
import script from "./MediaFiliacionComponent.vue?vue&type=script&lang=js"
export * from "./MediaFiliacionComponent.vue?vue&type=script&lang=js"
import style0 from "./MediaFiliacionComponent.vue?vue&type=style&index=0&id=28e3f784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e3f784",
  null
  
)

export default component.exports